import { PUP_DISPLAY_NAME } from "../config"

export function getShowAuthorization(t: TrelloIframe) {
  return t.modal({
    title: PUP_DISPLAY_NAME,
    url: "./show-authorization.html",
    height: 350,
  })
}
